module.exports = __webpack_public_path__ + "static/media/Icon_7F463D.12bb35d5.png";